import { useCompoundBody } from "@react-three/cannon";
import { useRef } from "react";
import { Group } from "three";
import { Cylinder, ObjectProps, Sphere, useDragConstraint } from "../utils";

export default ({position, rotation}: ObjectProps) => {
  const [ref] = useCompoundBody(() => ({
    mass: 3,
    position: position ?? [0, 0, 0],
    rotation: rotation ?? [0, 0, 0],
    shapes: [
      { type: 'Cylinder', position: [0, -0.5, 0], rotation: [0, 0, Math.PI / 2], args: [0.2, 0.2, 20] },
      
      { type: 'Sphere', position: [-10, -0.5, 0], args: [0.3] },
      { type: 'Cylinder', position: [-10, 0, 0], args: [0.2, 0.2, 1] },
      { type: 'Cylinder', position: [-10, 0.4, 0], args: [0.25, 0.25, 0.225] },
      
      { type: 'Sphere', position: [0, -0.5, 0], args: [0.3] },
      { type: 'Cylinder', position: [0, 0, 0], args: [0.2, 0.2, 1] },
      { type: 'Cylinder', position: [0, 0.4, 0], args: [0.25, 0.25, 0.225] },
      
      { type: 'Sphere', position: [10, -0.5, 0], args: [0.3] },
      { type: 'Cylinder', position: [10, 0, 0], args: [0.2, 0.2, 1] },
      { type: 'Cylinder', position: [10, 0.4, 0], args: [0.25, 0.25, 0.225] },
    ], 
    type: 'Static',
  }), useRef<Group>(null));
  const bind = {}; // useDragConstraint(ref);
  return (
    <group ref={ref} {...bind} >
      <Cylinder position={[0, -0.5, 0]} rotation={[0, 0, Math.PI / 2]} args={[0.2, 0.2, 20, 16]} />

      <Sphere position={[-10, -0.5, 0]} args={[0.3]} />
      <Cylinder position={[10, 0, 0]} args={[0.2, 0.2, 1, 16]} />
      <Cylinder position={[10, 0.4, 0]} args={[0.3, 0.2, 0.225, 16]} color="#2a2a2a"/>

      <Sphere position={[0, -0.5, 0]} args={[0.3]} />
      <Cylinder position={[0, 0, 0]} args={[0.2, 0.2, 1, 16]} />
      <Cylinder position={[0, 0.4, 0]} args={[0.3, 0.2, 0.225, 16]} color="#2a2a2a"/>

      <Sphere position={[-10, -0.5, 0]} args={[0.3]} />
      <Cylinder position={[-10, 0, 0]} args={[0.2, 0.2, 1, 16]} />
      <Cylinder position={[-10, 0.4, 0]} args={[0.3, 0.2, 0.225, 16]} color="#2a2a2a"/>
    </group>
  );
};
